import type {
  BuyflowWidget,
  GetNextBuyflowStepResponse,
  PhoneQuestionnaireValue,
  PhoneQuestionnaireWidget,
} from '@/lib/TypesOpenApi';
import {persist} from '@/lib/vatio-persistence';
import {proxy, useSnapshot} from 'valtio';
import {
  type StepWidgetStore,
  StepsPath,
  stepsMap,
} from '../routing/StepsRouting';
import {useWidget} from '../routing/StepsWizardContext';

const widget = stepsMap['PHONE_QUESTIONNAIRE']!.store;

export interface PhoneQuestionnairePageWidget {
  /** Base widget to relay on */
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  productWidget?: PhoneQuestionnaireWidget;
}

export const phoneQuestionnaireWidget = proxy<PhoneQuestionnairePageWidget>({
  widget,
  get content() {
    return this.widget.content;
  },

  get productWidget() {
    const widgets =
      this.content?.buyflowStep.buyflowWidgets
        ?.map(({phoneQuestionnaireWidget: w}: BuyflowWidget) => w!)
        .filter((w: BuyflowWidget) => !!w) || [];
    return widgets[0];
  },
});

export const usePhoneQuestionnaireWidget = () =>
  useWidget(StepsPath.PhoneQuestionnaire, phoneQuestionnaireWidget);

export interface PhoneQuestionnaireState {
  selected: PhoneQuestionnaireValue[];
}

// if add any new field, add the new field to the below reset function also
export const store = persist<PhoneQuestionnaireState>(
  StepsPath.PhoneQuestionnaire,
  {
    selected: [],
  },
);

export const resetPhoneQuestionnaireState = () => {
  store.selected = [];
};

export function setDefaultSelection() {
  if (store.selected.length) {
    return;
  }

  phoneQuestionnaireWidget.productWidget?.options?.forEach(x => {
    if (!x.selected || !x.value) {
      return;
    }
    store.selected.push(x.value);
  });
}

export function setSelected(value: PhoneQuestionnaireValue) {
  if (store.selected.includes(value)) {
    store.selected = store.selected.filter(x => x !== value);

    if (!store.selected.length && value !== 'NONE_OF_THESE') {
      store.selected.push('NONE_OF_THESE');
    }

    return;
  }

  if (value === 'NONE_OF_THESE') {
    store.selected = [] as PhoneQuestionnaireValue[];
  } else {
    store.selected = store.selected.filter(x => x !== 'NONE_OF_THESE');
  }
  store.selected.push(value);
}

export const usePhoneQuestionnaireState = () => useSnapshot(store);
